import Vue from 'vue'
import App from './App.vue'
// import { createProvider } from './vue-apollo'
import { apolloProvider } from '@/graphql/apollo-client'
import router from './router';
import store from './store';
import i18n from './i18n';
import './assets/css/tailwind.css';
/* @ts-ignore */
import * as GmapVue from 'gmap-vue';
import VueErdJsPlugin from 'vue-erdjs'

Vue.config.productionTip = false
Vue.use(GmapVue, {
  load: {
    key: 'AIzaSyBZiLp-afkWQ4JMSRnrpEnE_0dqnX-hZtw'
  }
})

Vue.use(VueErdJsPlugin)

/* @ts-ignore */
window.powerbank = new Vue({
  apolloProvider,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
